import store from '@/store'

const isStaging = process.env.NODE_ENV === 'staging'
const api = isStaging ? '/api-staging' : '/api'

export const fakeFetch = (data, time = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data)
    }, time)
  })
}

export const fetchResource = async (path, params = {}, options = { ignoreNotFound: false }) => {
  // create the query string
  const esc = encodeURIComponent
  const query = Object.keys(params)
    .filter((k) => !!params[k])
    .map((k) => `${k}=${esc(params[k])}`)
    .join('&')
  const queryString = query.length > 0 ? `?${query}` : ''

  // perform the fetch
  try {
    const tenantKey = store.state.tenantStore.tenantKey
    const url =
      path && path !== tenantKey
        ? `${api}/tenant/${tenantKey}/${path}${queryString}`
        : `${api}/tenant/${tenantKey}${queryString}`
    // console.debug(`[fetchService]: FETCH ${url}`)
    const response = await fetch(url)

    if (response.ok) {
      return response.json() // intentionally return a promise
    } else if (response.status === 404 && options.ignoreNotFound) {
      return null
    } else {
      throw new Error(response.statusText)
    }
  } catch (error) {
    console.error(`[fetchService]: GET ${path}`, error)
    throw error
  }
}

export const postResource = async (resource, body) => {
  try {
    const tenantKey = store.state.tenantStore.tenantKey
    const url = `${api}/tenant/${tenantKey}/${resource}`
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body })
    }
    const response = await fetch(url, options)
    if (response.ok) {
      return response.json()
    } else {
      throw new Error(response.statusText)
    }
  } catch (error) {
    console.error(`[fetchService]: POST ${resource}`, error)
    throw error
  }
}

export const putResource = async (resource, body) => {
  try {
    const tenantKey = store.state.tenantStore.tenantKey
    const url = `${api}/tenant/${tenantKey}/${resource}`
    const options = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body })
    }
    const response = await fetch(url, options)
    if (response.ok) {
      return response.json()
    } else {
      throw new Error(response.statusText)
    }
  } catch (error) {
    console.error(`[fetchService]: PUT ${resource}`, error)
    throw error
  }
}

export const deleteResource = async (resource, body = {}) => {
  try {
    const tenantKey = store.state.tenantStore.tenantKey
    const url = `${api}/tenant/${tenantKey}/${resource}`
    const options = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body })
    }
    const response = await fetch(url, options)
    if (response.ok) {
      return response.json()
    } else {
      throw new Error(response.statusText)
    }
  } catch (error) {
    console.error(`[fetchService]: DELETE ${resource}`, error)
    throw error
  }
}
